module.exports = __webpack_public_path__ + "img/polymath-logo.8f2f90d2.svg";